import { useRouteTrace } from '@/modules/Project/routing/useRouteTrace'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const useEntitySidebarNavigation = () => {
  const router = useRouter()
  const route = useRoute()

  const openSidebar = (entityId: string) => router.push({ query: { ...route.query, entityId } })
  const closeSidebar = () => router.push({ query: { ...route.query, entityId: undefined } })

  const { getSerializedTrace } = useRouteTrace()

  const resolveEntitySidebarRoute = (workspaceId: string, projectId: string, entityId: string) => {
    const trace = getSerializedTrace()
    if (route.name === 'CaseDetails') {
      return {
        name: 'WorkspaceProjectTable',
        params: { workspaceId, projectId },
        query: { entityId, trace },
      }
    }

    return { query: { ...route.query, entityId, trace } }
  }

  const isSidebarOpen = computed(() => route.query.entityId !== undefined)

  return { closeSidebar, resolveEntitySidebarRoute, isSidebarOpen, openSidebar }
}
